export const httpError = Symbol('httpError');

/**
 * Creates an Error with an 'http' property containing detail information.
 *
 * @param hash
 * @return {Error}
 */

export const createHttpError = (hash) => {
  const error = new Error(`${hash.statusCode} ${hash.statusMessage}`);
  error.type = httpError;
  error.statusCode = hash.statusCode;
  error.http = hash;
  return error;
};

export const httpStatusCodes = {
  unauthorized: 401,
};

/**
 * Checks a response's overall status code, bailing out on anything that is not within the 2XX range.
 *
 * @param response
 */

export const checkStatus = async (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  if (response.status === 401) {
    throw createHttpError({ statusCode: response.status, statusMessage: response.statusText });
  }
  const { error } = await response.json();
  throw new Error(error);
};
